import { Language } from "../languages";

export const commonTranslations: Record<Language, any> = {
  es: {
    nav: {
      home: "Inicio",
      history: "Historia",
      characters: "Personajes",
      world: "Mundo",
      downloads: "Descargas",
      community: "Comunidad",
      register: "Registrarse",
      profile: "Mi Perfil",
      login: "Iniciar Sesión",
      logout: "Cerrar Sesión",
    },
    footer: {
      explore: "Explorar",
      home: "Inicio",
      features: "Características",
      gallery: "Galería",
      characters: "Personajes",
      history: "Historia",

      resources: "Recursos",
      downloads: "Descargas",
      patches: "Parches",
      guides: "Guías",
      FAQ: "FAQ",
      support: "Soporte",

      community: "Comunidad",
      forums: "Foros",
      events: "Eventos",
      clans: "Clanes",
      contests: "Concursos",
      wiki: "Wiki",

      connect: "Conecta",
      followUs:
        "Síguenos en redes sociales para las últimas actualizaciones y noticias:",
      copyRight:
        "AETHELBUR CHRONICLES RPG | Todos los derechos reservados| Desarrollado con",
      company: "por el Reino de Aethelbur",
    },
    buttons: {
      play: "Jugar Ahora",
      download: "Descargar",
      learnMore: "Saber Más",
      subscribe: "Suscribirse",
      logout: "Cerrar Sesión",
      login: "Iniciar Sesión",
      forgotPassword: "¿Olvidaste tu contraseña?",
    },
    AuthSidebar: {
      playerPortal: "PORTAL DEL JUGADOR",
      loading: "Cargando...",
      email: "Email",
      emailPlaceholder: "Ingresa tu email",
      password: "Contraseña",
      passwordPlaceholder: "Ingresa tu contraseña",
      loggingIn: "Iniciando sesión...",
      receiveNews: "¡Recibe noticias exclusivas y actualizaciones!",
      version: "Version actual: ",
      lastVersion: " | Última actualización: ",
      welcome: "Bienvenido",
    },
  },
  en: {
    nav: {
      home: "Home",
      history: "History",
      characters: "Characters",
      world: "World",
      downloads: "Downloads",
      community: "Community",
      register: "Register",
      profile: "My Profile",
      login: "Login",
      logout: "Logout",
    },
    footer: {
      explore: "Explore",
      home: "Home",
      features: "Features",
      gallery: "Gallery",
      characters: "Characters",
      history: "History",

      resources: "Resources",
      downloads: "Downloads",
      patches: "Patches",
      guides: "Guides",
      FAQ: "FAQ",
      support: "Support",

      community: "Community",
      forums: "Forums",
      events: "Events",
      clans: "Clans",
      contests: "Contests",
      wiki: "Wiki",

      connect: "Connect",
      followUs: "Follow us on social media for the latest updates and news:",
      copyRight:
        "AETHELBUR CHRONICLES RPG | all rights reserved | Developed with",
      company: "by the Kingdom of Aethelbur",
    },
    buttons: {
      play: "Play Now",
      download: "Download",
      learnMore: "Learn More",
      subscribe: "Subscribe",
      logout: "Logout",
      login: "Login",
      forgotPassword: "Forgot your password?",
    },
    AuthSidebar: {
      playerPortal: "PLAYER PORTAL",
      loading: "Loading...",
      email: "Email",
      emailPlaceholder: "Enter your email",
      password: "Password",
      passwordPlaceholder: "Enter your password",
      loggingIn: "Logging in...",
      receiveNews: "Receive exclusive news and updates!",
      version: "Current version: ",
      lastVersion: " | Last updated: ",
      welcome: "Welcome",
    },
  },
};
